import owd from 'owd/owd';

export default class VimeoPlayer extends owd.Component {
	init() {
        this.videoPlayerWrapper = this.$element.find('.video-item');
        this.videoButtonPlay = this.$element.find('.video-button--play');
        this.videoUrl = this.$element.data('vimeoPlayer');
        this.player = null;
        
        this.initPlayer();
		this.bind();
	}
    
    initPlayer() {
        this.player = new Vimeo.Player(this.videoPlayerWrapper, {
            url: this.videoUrl,
            width: 1920,
            badge: false,
            portrait: false,
            byline: false,
            title: false,
        });
    }

    showButtonPlay() {
        this.videoButtonPlay.removeClass('is-hidden'); 
    }
    
	bind() {
        this.player.on('pause', this.showButtonPlay.bind(this));
        
        this.on('click', this.videoButtonPlay, () => {
            this.videoButtonPlay.addClass('is-hidden');
            this.player.play();
        });
    }

    destroy() {
        if(this.player !== null) {
            this.player.off('pause', this.showButtonPlay.bind(this));
            this.player.destroy();
        }
        
        super.destroy();
    }
}

owd.registerComponent('vimeo-player', {
	component: VimeoPlayer
});
